import { Box, makeStyles } from '@material-ui/core';
import { WbButton } from '../../WbButton';
import { FC, MouseEventHandler } from 'react';

const useStyles = makeStyles(
  () => ({
    root: {
      '& span': {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        display: 'inline-block',
        maxWidth: '100%',
      },
    },
  }),
  { name: 'WbTitleButtonCell' },
);

export const WbTitleButtonCell: FC<{
  title: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
}> = ({ onClick, title }) => {
  const classes = useStyles();
  return (
    <Box display="flex">
      <WbButton
        className={classes.root}
        onClick={onClick}
        variant="text"
        label={title}
        type="button"
      />
    </Box>
  );
};
